module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Broadcast_16"],"path":[{"$":{"d":"M4.39,9.61a5.1,5.1,0,0,1,0-7.21l.85.85a3.9,3.9,0,0,0,0,5.51ZM13.1,6a5.07,5.07,0,0,0-1.49-3.61l-.85.85a3.9,3.9,0,0,1,0,5.51l.85.85A5.07,5.07,0,0,0,13.1,6ZM3.47,10.53a6.41,6.41,0,0,1,0-9.05L2.63.63a7.61,7.61,0,0,0,0,10.75Zm9.9-9.9-.85.85a6.41,6.41,0,0,1,0,9.05l.85.85A7.61,7.61,0,0,0,13.37.63ZM10,6A2,2,0,1,0,7,7.72V16H9V7.72A2,2,0,0,0,10,6Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Broadcast_16.svg
// module id = zHrA
// module chunks = 1